export default __webpack_public_path__ + "static/media/img9.821eb87e.png";